import type { ContactLifecycle } from '@epasu/core/constants';

/**
 * Wo die Akte eines Kontakts liegt.
 *
 * Leads und Kontakte teilen sich eine Detailseite, aber nicht die Adresse. Vorher
 * gab es nur `/kontakte/:id`: wer aus einer Kampagne oder der Leads-Liste einen
 * Lead öffnete, landete optisch in „Kontakte“ — die Seitenleiste sprang um, und
 * „Alle Kontakte“ führte dorthin, wo der Lead gar nicht steht. Die Adresse
 * entscheidet, welcher Bereich markiert ist, also braucht der Lead seine eigene.
 */
export function aktePfad(contactId: string, lifecycle: ContactLifecycle = 'kontakt'): string {
  return lifecycle === 'lead' ? `/leads/lead/${contactId}` : `/kontakte/${contactId}`;
}

/** Liegt die Adresse im Leads-Bereich? */
export function istLeadAkte(pathname: string): boolean {
  return pathname.startsWith('/leads/lead/');
}
